import {
  Toast
} from "vant";
import Vue from "vue";
import store from "@/store";
const websocket = {
  ws: null,
  isConnect: false,
  timer: null,
  onMessageArrived: null,
  closeBackCall: null,
  num: 0,
  onSubscrib: null,
  isError: false,
  handleConnect(token,type) { //创建连接socket
    let that = this;
    this.num++;
    return new Promise((resolve, reject) => {
      if (this.num < 6 && !this.isConnect) {
        this.ws = null;
        this.ws = new WebSocket("ws://chat.gaozhaotong.cn/chat?token=" + token + "&num=" + this.num + "&chatType=" + store.state.chatType+"&type=" + type);
        this.ws.Date = new Date()
        this.ws.onopen = function () {
          var data = "socket消息：建立连接成功";
          that.isConnect = true;
          Vue.prototype.$setConnectSocketOK(true);
          console.log(data, that.onSubscrib);
          if (that.onSubscrib) {
            that.handleSubscrib(that.onSubscrib)
          }
          resolve(data)
        };
        this.handleMessage()
        this.ws.onerror = function (e) {
          var data = "socket消息 : 出错了,请退出重试.";
          // that.ws = null;
          that.isConnect = false;
          Vue.prototype.$setConnectSocketOK(false);
          if (that.timer) {
            clearInterval(that.timer)
          }
          console.log(data, e);
          reject(data)
        };
        this.ws.onclose = function (e) {
          var data = "socket消息 :连接断开";
          // that.ws = null;
          that.isConnect = false;
          Vue.prototype.$setConnectSocketOK(false);
          if (that.timer) {
            clearInterval(that.timer)
          }
          console.log(data, that.num, e);
          // 重新连接5次
          if (!this.isError) {
            setTimeout(() => {
              if (that.num < 6 && !that.isConnect) {
                that.handleConnect(token,1);
              }
            }, 200)
          }
          reject(data)
        };
      } else {
        // socket连接不上了切换成mqtt
        console.log("setChatType");
        Vue.prototype.$setChatType(2)
      }
    })
  },
  handleMessage() {
    let that = this;
    this.ws.onmessage = function (e) {
      // console.log(e);
      var msg = JSON.parse(e.data);
      console.log("socket消息:", msg);
      if (msg.Type == "Login") {
        if (that.timer) {
          clearInterval(that.timer)
        }
        that.sendPing(msg)
      } else if (msg.Type == "error") {
        this.isError = true
      } else if (msg.Type != "ping" && msg.Type != "unsubscribe") {
        if (that.onMessageArrived != null) {
          that.onMessageArrived(msg)
        }
      }
    };
  },
  sendPing(msg) {
    let that = this;
    that.timer = setInterval(() => {
      var data = {
        'Type': 'ping',
        'Displayname': JSON.parse(msg.Content).User.Displayname
      };
      console.log(data);
      that.handleSend(data)
    }, 10000);
  },
  handleSubscrib(Topic) { //订阅房间
    console.log("handleSubscrib");
    return new Promise((resolve, reject) => {
      let data = {
        'Type': 'subscribe',
        'Content': Topic,
      };
      this.handleSend(data).then(() => {
        this.onSubscrib = Topic
        resolve()
      })
    })
  },
  handleUnsubscribe(Topic) {
    return new Promise((resolve, reject) => {
      let data = {
        'Type': 'unsubscribe',
        'Content': Topic,
      };
      this.handleSend(data).then(() => {
        resolve()
      })
    })
  },
  handleSend(Data) { //发送消息
    return new Promise((resolve, reject) => {
      console.log(Data, this.ws, this.isConnect);
      var data = JSON.stringify(Data);
      if (this.ws && this.isConnect) {
        this.ws.send(data);
        resolve()
      } else {
        // let that = this
        // // Toast("socket断开连接了")
        // console.log("socket断开连接了");
        // let token = lycamWeb.getCookie("token")
        // if (window.location.href.indexOf("localhost") > -1) {
        //   token = store.state.myToken
        // }
        // if (that.timer) {
        //   clearInterval(that.timer)
        // }
        // if (that.closeBackCall != null) {
        //   if (Data.Type != "ping") {
        //     that.handleConnect(token,2)
        //   }
        //   that.closeBackCall();
        // }
        // setTimeout(() => {
        //   that.handleSend(Data);
        // }, 100)
      }
    })
  },
}

export default websocket



// WEBPACK FOOTER //
// ./src/assets/socket/index.js